import i18n from '@/vendors/i18n'

export default class Link {
  constructor ({ show, url = i18n.getLocalesTranslations(), icon = null, text = i18n.getLocalesTranslations(), target_url = null, type = null } = {}) {
    this.show = typeof show == 'boolean' ? show : true
    this.url = url
    this.icon = icon
    this.text = text
    this.target_url = target_url
    this.type = type
  }
}
